import React from 'react';

import { DateInput, NO_POINT_IN_TIME, dates, isPointInTime } from '~library/dates';

import { CustomTooltip } from '../Tooltip';

export { NO_POINT_IN_TIME };

// Measured in Chrome, 2026-10-28: an en-US / en-DE absolute time fits on one line at the table font
// size; a recent time's age wraps below it. Longer day periods (en-CA "p.m.") may wrap.
export const POINT_IN_TIME_COLUMN_WIDTH = 190;

// For `tableLayout="auto"` tables (antd's default without `scroll.y`), where a column `width` is only a hint
// and the cell shrinks below it.
export const pointInTimeCell = (): React.TdHTMLAttributes<HTMLTableCellElement> => ({
  style: { minWidth: POINT_IN_TIME_COLUMN_WIDTH },
});

const NO_WRAP_WITHIN_PART: React.CSSProperties = { whiteSpace: 'nowrap' };

type PointInTimeProps = {
  value: DateInput | null | undefined;
  label?: string;
};

function PointInTime({ value, label }: PointInTimeProps) {
  if (!isPointInTime(value)) return <>{NO_POINT_IN_TIME}</>;

  const { date, time } = dates.pointInTimeParts(value);
  const age = dates.recentAge(value);
  const fullTimestamp = dates.fullTimestamp(value);
  const tooltip = label ? `<span><b>${label}</b><br />${fullTimestamp}</span>` : fullTimestamp;

  return (
    <CustomTooltip placement="top" message={tooltip}>
      <time dateTime={new Date(value).toISOString()}>
        <span style={NO_WRAP_WITHIN_PART}>{date}</span> <span style={NO_WRAP_WITHIN_PART}>{time}</span>
        {age && (
          <>
            {' '}
            <span style={NO_WRAP_WITHIN_PART}>({age})</span>
          </>
        )}
      </time>
    </CustomTooltip>
  );
}

export default PointInTime;
